module.exports = __webpack_public_path__ + "static/SLFCspread-3-94f5f470da89f86717148932e811c75c.jpg";